/**
 * Play Space Brain Customer Portal — theme colors
 *
 * This file is the single switching point for the two color palettes the
 * portal ships with. Every other theme file (typography, boxShadows, and
 * ~40 MUI component style overrides) statically imports its colors from
 * this path, so switching the export here is enough to re-theme the whole
 * MUI palette — nothing downstream needs to know a "standard" variant
 * exists.
 *
 * - colors.premium.js: the default brand palette (ink navy + brewed gold).
 * - colors.standard.js: a neutral, close-to-original palette with a white
 *   background, for portals embedded in a host site.
 *
 * The variant is picked via getThemeVariant() (see themeVariant.js), which
 * reads the same PSB_THEME embed marker that index.js uses to toggle the
 * matching psb-theme-standard CSS class for plain (non-MUI) styles.
 */

import premiumColors from "./colors.premium";
import standardColors from "./colors.standard";
import {getThemeVariant} from "../../../common/themeVariant";

const colors = getThemeVariant() === "standard" ? standardColors : premiumColors;

export default colors;
